module.exports = __webpack_public_path__ + "img/alfa+romeo.620f43b1.png";